import type {
  AuthenticationResponseJSON,
  RegistrationResponseJSON,
} from "@simplewebauthn/browser";

export function jsonSafeAuthenticationResponse(
  credential: AuthenticationResponseJSON,
): AuthenticationResponseJSON {
  return {
    id: credential.id,
    rawId: credential.rawId,
    response: {
      clientDataJSON: credential.response.clientDataJSON,
      authenticatorData: credential.response.authenticatorData,
      signature: credential.response.signature,
      ...(credential.response.userHandle === undefined
        ? {}
        : { userHandle: credential.response.userHandle }),
    },
    type: credential.type,
    clientExtensionResults: credential.clientExtensionResults,
    ...(credential.authenticatorAttachment === undefined
      ? {}
      : { authenticatorAttachment: credential.authenticatorAttachment }),
  };
}

export function jsonSafeRegistrationResponse(
  credential: RegistrationResponseJSON,
): RegistrationResponseJSON {
  return {
    id: credential.id,
    rawId: credential.rawId,
    response: {
      clientDataJSON: credential.response.clientDataJSON,
      attestationObject: credential.response.attestationObject,
      ...(credential.response.authenticatorData === undefined
        ? {}
        : { authenticatorData: credential.response.authenticatorData }),
      ...(credential.response.transports === undefined
        ? {}
        : { transports: credential.response.transports }),
      ...(credential.response.publicKeyAlgorithm === undefined
        ? {}
        : { publicKeyAlgorithm: credential.response.publicKeyAlgorithm }),
      ...(credential.response.publicKey === undefined
        ? {}
        : { publicKey: credential.response.publicKey }),
    },
    type: credential.type,
    clientExtensionResults: credential.clientExtensionResults,
    ...(credential.authenticatorAttachment === undefined
      ? {}
      : { authenticatorAttachment: credential.authenticatorAttachment }),
  };
}
